import * as Amplitude from '@amplitude/analytics-browser';

// Note, in the flow of amplitude-js an initial action is
// to check if cookies are available. This does not respect
// the below same-site settings, however the actual cookie
// (generated after seeing cookies are available) will be under
// valid same-site settings.
// Actual cookie prefix = amp
// Test cookies available cookie prefix = amp_cookie_test
async function init(apiKey, user) {
  await Amplitude.init(
      apiKey,
      user.email,
      {
        defaultTracking: true,
        cookieSameSite: "Lax",
        cookieSecure: true,
        secure: true
      }
    ).promise;
}

// Used once on page load to set default user properties
// In Amplitude this is sent along with every event
function identify(user) {
  const id = new Amplitude.Identify();

  id.setOnce('user_id', user.id)
    .setOnce('email', user.email)
    .setOnce('name', user.name)
    .setOnce('signInCount', user.signInCount)
    .setOnce('insertedAt', user.insertedAt)
    .setOnce('currentSignInAt', user.currentSignInAt)
    .setOnce('organisationId', user.organisationId)
    .setOnce('organisationName', user.organisationName)

  Amplitude
    .identify(id)
}

// Track an event
function trackEvent(eventName, eventProperties) {
  Amplitude
    .logEvent(eventName, eventProperties)
}

export default {
  init, identify, trackEvent
}
